import { ref, readonly } from 'vue';
import { createGlobalState } from '@vueuse/core';

export const useAppUpdate = createGlobalState(() => {
    const isUpdateAvailable = ref(false);

    function notifyUpdateAvailable() {
        isUpdateAvailable.value = true;
    }

    return {
        isUpdateAvailable: readonly(isUpdateAvailable),
        notifyUpdateAvailable,
    };
});
